import axios from 'axios';
import qs from 'qs';

export default class extends axios {
  constructor(...props) {
    super(...props);
    if (process.env.NODE_ENV == 'development') {
      this.defaults.baseURL = 'https://api.bigfix.co/demo2';
    } else {
      let parts = window.location.hostname.split('.');
      const DOMAINNAME = parts[1] + '.' + parts[2];
      const SITE_APP = parts.shift();
      this.defaults.baseURL = 'https://api.' + DOMAINNAME + '/' + SITE_APP;
    }
    //this.defaults.headers.common['x-access-token'] = AUTH_TOKEN;
    //this.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    this.config = {
      withCredentials: true,
    };
    this.interceptors.request.use(function(config) {
      // Do something before request is sent
      config['withCredentials'] = true;
      //if(config['method']==='post'){
      //config['headers']['Accept'] = '*/*'
      //config['headers']['Content-Type']  = "application/x-www-form-urlencoded; charset=UTF-8"
      //config['headers']['http-x-requested-with'] = 'XMLHttpRequest'
      //config['headers']['X-Requested-With'] = 'XMLHttpRequest'
      // }
      //console.log('config',config)

      return config;
    }, function(error) {
      // Do something with request error
      return Promise.reject(error);
    });
  }
}




// WEBPACK FOOTER //
// ./src/utils/api.js